module.exports = __webpack_public_path__ + "static/media/gmail-send.9e038052.png";